import styled, {createGlobalStyle} from "styled-components";
import {Drawer, Button, Input} from "antd";

export const EmailAutomationsActionsDropdownStyles = createGlobalStyle`
  .email-automations-actions-dropdown .ant-dropdown-menu-item:hover {
    font-weight: 600;
  }
`;

export const StyledAutomationsPageContent = styled.div`
  margin-top: 1.5rem;
  width: 100%;
  max-width: 100%;
`;

export const StyledAutomationsTabsContainer = styled.div`
  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-tab {
    font-size: 1.5rem;
    font-weight: 500;
    color: #8c8c8c;
    padding: 1.2rem 0;

    &.ant-tabs-tab-active {
      font-weight: 600;
      color: #1c1726;
    }
  }

  .ant-tabs-ink-bar {
    background-color: #1c1726;
    height: 3px;
  }

  .ant-tabs-content {
    padding-top: 2.4rem;
  }
`;

export const StyledAutomationsTabDescription = styled.p`
  font-size: 1.4rem;
  color: #595959;
  margin: 0 0 2.4rem 0;
  line-height: 1.5;
`;

export const StyledAutomationsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(28rem, 1fr));
  gap: 1.6rem;
  width: 100%;

  .automation-card-link {
    display: block;
    height: 100%;
  }
`;

export const StyledAutomationCard = styled.div<{
  $borderColor?: string;
  $clickable?: boolean;
}>`
  background-color: #ffffff;
  border: 1px solid ${({$borderColor}) => $borderColor ?? "#e8e8e8"};
  border-radius: 1.2rem;
  padding: 1.6rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  min-height: 16rem;
  box-sizing: border-box;
  ${({$clickable}) =>
    $clickable &&
    `
    cursor: pointer;
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      border-color: #d0d0d0;
    }
  `}

  .automation-card-icon-wrap {
    width: 4rem;
    height: 4rem;
    border-radius: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.8rem;
    flex-shrink: 0;
  }

  .automation-card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    gap: 1rem;
  }

  .automation-card-title {
    min-width: 0;
    font-size: 1.4rem;
    font-weight: 600;
    color: #1c1726;
    margin: 0;
    overflow-wrap: anywhere;
  }

  .automation-card-desc {
    font-size: 1.4rem;
    color: #595959;
    line-height: 1.5;
    margin: 0.8rem 0 0;
    flex: 1;
    overflow-wrap: anywhere;
  }

  .automation-card-coming-soon {
    padding: 0.4rem 0.8rem;
    background-color: #fffbe6;
    color: #faad14;
    font-size: 1.2rem;
    border: 1px solid #ffe58f;
    font-weight: 600;
    border-radius: 2px;
    flex-shrink: 0;
    white-space: nowrap;
  }

  .automation-card-connected {
    padding: 0.4rem 0.8rem;
    background-color: #f6ffed;
    color: #52c41a;
    font-size: 1.2rem;
    border: 1px solid #b7eb8f;
    font-weight: 600;
    border-radius: 2px;
    flex-shrink: 0;
    white-space: nowrap;
  }
`;

export const StyledIntegrationDetailHeader = styled.div`
  margin-bottom: 2.4rem;

  .ant-breadcrumb {
    font-size: 2rem;
    margin-top: 0.8rem;
  }

  .ant-breadcrumb a {
    color: #8c8c8c;
    font-weight: 600;
  }

  .ant-breadcrumb li:last-child {
    color: #1c1726;
  }
`;

export const StyledIntegrationDetailCard = styled.div`
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 0.8rem;
  padding: 1.6rem;
  width: 100%;
`;

export const StyledIntegrationDetailLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2.4rem;
  align-items: stretch;

  @media only screen and (min-width: 768px) {
    grid-template-columns: minmax(20rem, 28rem) 1fr;
    gap: 3.2rem;
    align-items: stretch;
  }
`;

export const StyledIntegrationVisualBox = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 0.8rem;
  padding: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.4rem;
  min-height: 16rem;
  width: 100%;

  .integration-link-icon {
    color: #222;
    font-size: 1.6rem;
    border: 1px solid #f0f0f0;
    border-radius: 50%;
    padding: 0.8rem;
  }
`;

export const StyledIntegrationConnectPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 100%;

  h2 {
    font-size: 1.4rem;
    font-weight: 600;
    color: #1c1726;
    margin: 0;
    line-height: 1.4;
  }

  ul {
    margin: 0;
    padding-left: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
  }

  li {
    font-size: 1.4rem;
    color: #1c1726;
    line-height: 1.5;
  }
`;

export const StyledIntegrationStatusBanner = styled.div<{$variant: "info" | "success"}>`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.2rem 1.6rem;
  border-radius: 0.8rem;
  font-size: 1.4rem;
  line-height: 1.5;
  color: #1c1726;

  ${({$variant}) =>
    $variant === "info"
      ? `
    background-color: #E1F6F5;
    border: 1px solid #50D3CD;
  `
      : `
    background-color: #f6ffed;
    border: 1px solid #b7eb8f;
  `}

  .integration-status-banner-icon {
    flex-shrink: 0;
    font-size: 1.6rem;
    margin-top: 0.1rem;
  }

  .integration-status-emphasis {
    font-weight: 600;
  }

  ${({$variant}) =>
    $variant === "info"
      ? `
    .integration-status-banner-icon {
      color: #1c1726;
    }
  `
      : `
    .integration-status-banner-icon {
      color: #52c41a;
    }
  `}
`;

export const StyledIntegrationConnectButton = styled(Button)`
  width: 100%;
  border-radius: 1.2rem;
  font-size: 1.4rem;
  font-weight: 600;
  height: auto;
  padding: 1.2rem;

  &.ant-btn-primary {
    background: #1c1726;
    border-color: #1c1726;

    &:hover,
    &:focus {
      background: #2d2640;
      border-color: #2d2640;
    }
  }

  &.ant-btn-default {
    color: #1c1726;
    border-color: #1c1726;

    &:hover,
    &:focus {
      color: #1c1726;
      border-color: #1c1726;
      background: #f5f5f5;
    }
  }
`;

export const StyledIntegrationField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  label {
    font-size: 1.4rem;
    color: #1c1726;
  }

  .ant-input {
    border-radius: 0.8rem;
    padding: 1.2rem;
    font-size: 1.4rem;
    border: 1px solid #d9d9d9;

    &::placeholder {
      color: #bfbfbf;
    }

    &:hover,
    &:focus {
      border-color: #b0b0b0;
      box-shadow: none;
    }
  }

  .integration-field-helper {
    font-size: 1.3rem;
    color: #8c8c8c;
    line-height: 1.4;
    margin: 0;

    a {
      color: #1c1726;
      font-weight: 500;
      text-decoration: underline;
    }
  }
`;

export const StyledEmailAutomationsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

export const StyledEmptyStateBox = styled.div`
  padding: 3rem 2rem;
  background: #ebebeb;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  min-height: 17rem;
  margin-top: 1.5rem;

  .empty-state-text {
    font-size: 1.4rem;
    color: #595959;
    text-align: center;
    margin: 0;
  }
`;

export const StyledEmailAutomationsTableWrapper = styled.div`
  margin-top: 1.5rem;
  border-radius: 8px;
  overflow: hidden;

  .ant-table-wrapper .ant-table-thead > tr > th {
    background: #fafafa;
  }
  .ant-pagination-item {
    border: 0;
  }
`;

export const StyledCreateAutomationDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    width: 600px !important;
  }

  @media (max-width: 768px) {
    .ant-drawer-content-wrapper {
      width: 100% !important;
    }
  }

  .ant-drawer-header {
    border-bottom: 1px solid #f0f0f0;
    padding: 24px 0px;
    margin: 0px 24px;
  }

  .ant-drawer-header-title {
    flex-direction: row-reverse;
    justify-content: space-between;
    width: 100%;
  }

  .ant-drawer-title {
    font-size: 18px;
    font-weight: 600;
    color: #1c1726;
  }

  .ant-drawer-body {
    // margin: 24px;
    // background: #f5f5f5;
  }

  .ant-drawer-close {
    color: #1c1726;
    font-size: 18px;
  }

  .drawer-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 16px 24px;
    border-top: 1px solid #f0f0f0;
    background: #f5f5f5;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
  }

  .offering-drawer-automation-type-select.ant-select {
    width: 100%;
  }

  .offering-drawer-automation-type-select .ant-select-selector {
    border-radius: 8px !important;
    padding: 8px 12px !important;
    min-height: 48px;
    align-items: center;
  }
`;

/** Matches create-automation drawer: full viewport width on small screens. */
export const StyledViewAutomationDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    max-width: 100vw !important;
    width: 600px !important;
  }

  @media (max-width: 768px) {
    .ant-drawer-content-wrapper {
      width: 100% !important;
    }

    .ant-drawer-body {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }
  }

  /* Header padding from inline props wins on desktop; align with body on narrow screens */
  .ant-drawer-header {
    @media (max-width: 768px) {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }
  }

  /* Avoid long titles / tables forcing horizontal scroll of the viewport */
  .ant-drawer-body {
    overflow-x: hidden;
    box-sizing: border-box;
    max-width: 100%;
  }

  /* Inner scroll islands (e.g. tables) remain scrollable via Ant Table */
`;

export const StyledOfferingDrawerAutomationTypeBlock = styled.div`
  margin-bottom: 24px;
`;

export const StyledOfferingDrawerAutomationTypeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1c1726;
  margin-bottom: 8px;
`;

export const StyledOfferingDrawerAutomationReadonlyInput = styled(Input)`
  border-radius: 8px !important;
  padding: 8px 12px !important;
  min-height: 48px;
  align-items: center;

  &.ant-input[disabled],
  &:disabled.ant-input {
    color: rgba(28, 22, 38, 0.65);
    background: #fafafa !important;
    border-color: #d9d9d9;
    cursor: not-allowed;
  }
`;

export const StyledOfferingDrawerAutomationTypeHelper = styled.div`
  margin-top: 8px;
  font-size: 12px;
  font-weight: 400;
  color: #8c8c8c;
  line-height: 1.4;
`;

export const StyledOfferingDrawerAutomationTypeOptionInner = styled.div<{
  $disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-width: 0;

  .option-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .option-title {
    font-size: 14px;
    font-weight: 600;
    color: ${({$disabled}) => ($disabled ? "#bfbfbf" : "#1c1726")};
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .option-desc {
    font-size: 12px;
    font-weight: 400;
    color: ${({$disabled}) => ($disabled ? "#d9d9d9" : "#8c8c8c")};
    line-height: 1.4;
  }

  .option-selected-check {
    flex-shrink: 0;
    font-size: 14px;
    font-weight: 600;
    color: #1c1726;
    opacity: 0;
    width: 1.2em;
    text-align: center;
  }
`;

export const StyledOfferingDrawerAutomationPlaceholder = styled.div`
  padding: 24px;
  border-radius: 12px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  color: #8c8c8c;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
`;

export const OfferingDrawerAutomationTypeDropdownStyles = createGlobalStyle`
  .offering-drawer-automation-type-dropdown {
    padding: 8px 0;
  }

  .offering-drawer-automation-type-dropdown .ant-select-item-option {
    padding: 10px 12px !important;
    min-height: auto !important;
  }

  /* Rich option rows: avoid single-line truncation hiding subtitle */
  .offering-drawer-automation-type-dropdown .ant-select-item-option-content {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    line-height: 1.3;
  }

  .offering-drawer-automation-type-dropdown
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background: #f5f5f5 !important;
  }

  .offering-drawer-automation-type-dropdown
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled)
    .option-selected-check {
    opacity: 1;
  }
`;

export const StyledFormContainer = styled.div`
  background: #f5f5f5;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 24px;

  .form-header {
    font-size: 16px;
    font-weight: 600;
    color: #1c1726;
    margin-bottom: 8px;
  }
`;

export const StyledFormItem = styled.div`
  margin-bottom: 12px;

  .label-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;

    label {
      font-size: 14px;
      font-weight: 400;
      color: #1c1726;
    }

    .insert-link {
      color: #1c1726;
      font-size: 14px;
      font-weight: 600;
      text-decoration: underline;
      cursor: pointer;

      &:hover {
        color: #000;
      }
    }
  }

  .ant-input,
  .ant-input-affix-wrapper {
    border-radius: 2px;
    padding: 8px 12px;
    font-size: 16px;
    border: 1px solid #f0f0f0;

    &:hover,
    &:focus {
      border-color: #d9d9d9;
      box-shadow: none;
    }
  }

  .ant-form-item-explain-error {
    color: #ff4d4f;
    font-size: 13px;
    margin-top: 4px;
  }

  .ant-select-selector {
    border-radius: 2px !important;
    padding: 7px 12px !important;
    min-height: 44px !important;
    border: 1px solid #f0f0f0 !important;

    &:hover,
    &:focus,
    &:focus-within {
      border-color: #d9d9d9 !important;
      box-shadow: none !important;
    }
  }

  .ant-select-selection-item {
    font-size: 16px;
    color: #1c1726;
  }
`;

export const StyledTimingCard = styled.div<{active?: boolean}>`
  flex: 1;
  background: ${(props) => (props.active ? "#EAE6F3" : "#ffffff")};
  border: 1px solid ${(props) => (props.active ? "#1C1726" : "#f0f0f0")};
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) => (props.active ? "#1C1726" : "#d9d9d9")};
  }

  .timing-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;

    .timing-radio {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 1px solid ${(props) => (props.active ? "#1C1726" : "#d9d9d9")};
      background: ${(props) => (props.active ? "#fff" : "transparent")};
      position: relative;

      ${(props) =>
        props.active &&
        `
        &::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #1C1726;
        }
      `}
    }

    .timing-title {
      font-size: 14px;
      font-weight: 600;
      color: #1c1726;
    }
  }

  .timing-desc {
    font-size: 14px;
    color: #8c8c8c;
  }
`;

export const StyledShortCodeCard = styled.div`
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #1c1726;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }

  .short-code-title {
    font-size: 16px;
    font-weight: 700;
    color: #1c1726;
    margin-bottom: 4px;
  }

  .short-code-desc {
    font-size: 14px;
    color: #595959;
  }
`;

export const StyledQuillWrapper = styled.div`
  .quill {
    border-radius: 2px;
    overflow: hidden;
    border: 1px solid #f0f0f0;
  }

  .ql-toolbar.ql-snow {
    border: none;
    border-bottom: 1px solid #f0f0f0;
    background: #fafafa;
    padding: 8px 12px;
  }

  .ql-container.ql-snow {
    border: none;
    min-height: 200px;
    font-family: inherit;
    font-size: 16px;
  }

  .ql-editor {
    padding: 8px 12px;
    color: #1c1726;

    &.ql-blank::before {
      font-style: normal;
      color: #bfbfbf;
    }

    & p:has(br:only-child) {
      min-height: calc(1em * 1.42);
    }
  }
`;

export const StyledPreviewButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 32px;
  border-radius: 12px;
  border: 1px solid #1c1726;
  color: #1c1726;
  font-weight: 600;

  &:hover,
  &:focus {
    color: #1c1726;
    border-color: #1c1726;
    background: #f5f5f5;
  }
`;
